module.exports = __webpack_public_path__ + "img/good-horizontal-stairs.b8748fde.gif";